// Home, the Reception "Today" panel and the Settings overview
// (docs/plans/phase1-home-and-demo-data.md §2).
import { setupStatusSchema, todayVisitsSchema, unpricedItemsSchema } from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';

import { api } from './client.ts';

/** How often today's list refreshes while it is on screen. */
export const TODAY_REFRESH_MS = 30_000;

/** Today's visits at the session facility, newest first. */
export const todayVisitsQuery = (limit = 50) =>
  queryOptions({
    queryKey: ['visits', 'today', limit],
    queryFn: () =>
      api('GET', `/visits/today?limit=${String(limit)}`, { schema: todayVisitsSchema }),
    refetchInterval: TODAY_REFRESH_MS,
  });

export const setupStatusQuery = queryOptions({
  queryKey: ['setup-status'],
  queryFn: () => api('GET', '/setup-status', { schema: setupStatusSchema }),
  staleTime: 60_000,
});

export const unpricedItemsQuery = queryOptions({
  queryKey: ['catalogue', 'unpriced'],
  queryFn: () => api('GET', '/catalogue/unpriced?limit=5', { schema: unpricedItemsSchema }),
  staleTime: 60_000,
});
